import './polyfills/URLSearchParams';
import Vue from 'vue';
import {
  SyncsWithUrl,
  ResetsPage,
  CollectionComponent,
  ContinuousCollectionComponent,
  PaginatedCollectionComponent,
  PaginationNav,
} from 'clockvine-vue';
import store from './store';

// eslint-disable-next-line no-unused-vars
const app = new Vue({
  el: 'main[role="main"]',
  store,

  data: {
    params: {
      company: null,
      market: null,
      category: null,
      location: null,
      page: 1,
    },
  },

  computed: {
    showFeaturedItems() {
      return (
        this.params.company == null &&
        this.params.market == null &&
        this.params.page === 1
      );
    },
    hasMore() {
      return this.meta && this.params.page < this.meta.pagination.total_pages;
    },
  },

  mixins: [new SyncsWithUrl('params'), new ResetsPage()],

  components: {
    companies: CollectionComponent.for('companies'),
    markets: CollectionComponent.for('markets'),
    projects: ContinuousCollectionComponent.for('projects'),
    newsCategories: CollectionComponent.for('newsCategories'),
    newsItems: ContinuousCollectionComponent.for('newsItems'),
    communityCategories: CollectionComponent.for('communityCategories'),
    communities: ContinuousCollectionComponent.for('communities'),
    careerCategories: CollectionComponent.for('careerCategories'),
    careerLocations: CollectionComponent.for('careerLocations'),
    careers: PaginatedCollectionComponent.for('careers'),
    pagination: PaginationNav,
  },
});
